  const initialState = {
    step_status: {
        step_1: true,
        step_2: false,
        step_3: false,
        step_4: false,
    },
    data_step_1: {
      userName: '',
      email: '',
      password: '',
      confirmPassword: '',
    },
    data_step_2: {
      logo: '',
      backgroundColor: '#4ECDC4',
      firstName: '',
      lastName: '',
      phone: '',
      name: '',
      email: '',
      fleetId: '',
      address: '',
      website: '',
      driversNumber: '',
      vehiclesNumber: '',
    },
    data_step_3: {
      name: '',
      geo: {
        type: 'Point',
        coordinates: [],
      },
      address: '',
    },
    data_step_4: {
      selectedPlan: '',
    },
    isSubmitting: false,
    isSubmitted: false,
    submitError: null,
  };

  function initializeState() {
    return Object.assign({}, initialState);
  }
